/** Read budget for the booked-lesson card and its observers; other API calls retain their defaults. */
export const HOME_READ_TIMEOUT_MS = 15_000

/** Only queries owned by the home greeting are cleared by its retry action. */
export const HOME_GREETING_QUERY_META = { homeGreeting: true }
